module.exports = __webpack_public_path__ + "img/63.c0fff650.jpg";